export function isNavLinkActive(to, { pathname, hash }) {
  const [path, anchor] = to.split('#')
  if (anchor) return pathname === (path || '/') && hash === `#${anchor}`
  if (to === '/') return pathname === '/' && !hash
  return pathname === to || pathname.startsWith(`${to}/`)
}
